import { workforceNotificationsEntryPoint } from '@jira/personal-settings__workforce-notifications/src/workforceNotificationsEntryPoint.entrypoint.tsx';
import { MenuIdProfile } from '@jira/navigation-apps__constants/src/MenuIdProfile.tsx';
import { SidebarIdPersonalSettings } from '@jira/navigation-apps__constants/src/SidebarIdPersonalSettings.tsx';
import { getConsolidationStateResource } from '@jira/router-resources__eoc-tenant-info/src/getConsolidationStateResource.tsx';
import { notFoundPageEntrypoint } from '@jira/router-routes__not-found-entrypoint/src/ui/error-pages/not-found/index.tsx';
import { getNavigationForgePersonalSettingsPageResources } from '@jira/navigation-apps__resources/src/controllers/forge/index.tsx';
import { createEntry } from '@jira/platform__routing-route-entry/src/createEntry.tsx';
import { createPageEntryPoint } from '@jira/platform__routing-create-route-entry-point/src/index.tsx';
import { getNavigationResources } from '@jira/router-resources__navigation/src/getNavigationResources.tsx';
import { workforceNotificationsPersonalSettingsRoute } from '@jira/router-routes__personal-settings-routes/src/workforceNotificationsPersonalSettingsRoute.tsx';
import { opsNotificationsLayout } from '@jira/platform__layouts-ops-settings-layout/src/index.tsx';
import { fg } from '@atlassian/jira-feature-gating';
import type { Route } from '@atlassian/react-resource-router';

const workforceNotificationsPersonalSettingsPageEntryPoint = createPageEntryPoint({
	main: workforceNotificationsEntryPoint,
});

export const workforceNotificationsPersonalSettingsRouteEntry: Route = createEntry(
	workforceNotificationsPersonalSettingsRoute,
	() => ({
		group: 'personal-settings',
		layout: opsNotificationsLayout,

		navigation: {
			sidebarId: SidebarIdPersonalSettings,
			menuId: MenuIdProfile,
		},

		resources: [
			...getNavigationResources(),
			getConsolidationStateResource(),
			...getNavigationForgePersonalSettingsPageResources(),
		],

		entryPoint: () =>
			fg('jsm-workforce-upcoming-shift-reminder')
				? workforceNotificationsPersonalSettingsPageEntryPoint
				: notFoundPageEntrypoint,

		bifrost: {
			bifrostGroup: 'shell-only',
		},
	}),
);
